module.exports = __webpack_public_path__ + "img/default-banner.6957c201.png";